import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { contactDeveloper } from '@common/common';
import { DataService } from '@data/data.service';
import { NotificationService } from '@notification/notification.service';
import { UserDeviceService } from '@services/user-device.service';
import { tryToScrollDown } from '@util/visual-utils';
import SignaturePad from '../../../sigpad/signature_pad';
import { clearPad, resizeCanvas } from '../../../sigpad/sigpad_util';
import { FillAgbDialogComponent } from '../fill-agb-dialog/fill-agb-dialog.component';
import { setByDialogHeight } from '../../order-dialog.helper';
import { SpecialDocumentBase } from '../../special-document-base';
import { OrderDialogService } from '../../order-dialog.service';
import { updateCanvasSize } from '../../../image-edit/image-edit-util';
import { getClientRect } from '@util/web-utils';
import { isFunction } from '@util/utils';

@Component({
  selector: 'app-fill-receipt-dialog',
  templateUrl: './fill-receipt-dialog.component.html'
})
export class FillReceiptDialogComponent  extends SpecialDocumentBase implements OnInit {

  signatureStyle: any = {};
  signatureCanvasStyle: any = {};

  signaturePad: SignaturePad | null = null;

  private _signatureCanvas?: ElementRef;
  @ViewChild('signCanvas') set signPad(elem: ElementRef) {
    this._signatureCanvas = elem;
    this.signaturePad = updateCanvasSize(elem);
  }

  private _cnt?: ElementRef;
  @ViewChild('cnt') set contentRef(content: ElementRef) {
    this._cnt = content;
    setByDialogHeight(this._cnt?.nativeElement as HTMLElement);
  }

  constructor(
    public dialogRef: MatDialogRef<FillAgbDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    notificationService: NotificationService,
    private dataService: DataService,
    private userDeviceService: UserDeviceService,
    dialogService: OrderDialogService
  ) {
    super(notificationService);
    const dialogStyle = dialogService.getStylesForDialog('receipt',{});
    const signatureStyle = dialogStyle.signature;

    if(signatureStyle) {
      this.signatureStyle = signatureStyle?.pos || this.signatureStyle;
      this.signatureCanvasStyle = signatureStyle?.canvas || this.signatureCanvasStyle;
    }
  }

  ngOnInit(): void {
    const prefix = '/montage/documents/' + this.dialogData.orderId;
    this.signUrl = prefix + '/receipt/sign';
    this.editUrl = prefix + '/receipt/edit';

    this.deviceSub = this.userDeviceService.change().subscribe((ev: any) => {
      resizeCanvas(this._signatureCanvas?.nativeElement, this.signaturePad);
      setByDialogHeight(this._cnt?.nativeElement as HTMLElement);
    });

    this.requestEditData(
      this.editUrl,
      this.dataService,
      this.notificationService,
      'Problem beim Laden der Daten für Quittung'
    );
  }

  ngOnDestroy(): void {
    this.deviceSub.unsubscribe();
  }

  ngAfterViewInit(): void {
    tryToScrollDown(this._cnt?.nativeElement);
  }

  signClose(save: boolean) {

    if (save) {
      const p = this.signaturePad;

      if (!p) {
        this.notificationService.showErrors([
          'Unterschrift konnte nicht gelesen werden. ' + contactDeveloper
        ]);
        return;
      }
      if (p.isEmpty()) {
        this.notificationService.showErrors([
          'Sie habe keine Unterschrift gesetzt'
        ]);
        return;
      }
      const data = p.toDataURL(); // save image as PNG

      const reqData: any = {
        signature: data
      };

      this.dataService.post(this.signUrl, reqData, {}).subscribe((res: any) => {
        const data = res?.result;

        if (data.success) {
          this.notificationService.showSuccess(
            'Quittung gespeichert'
          );
          this.dialogRef.close(data);
        } else {
          this.notificationService.showErrors([
            data.error
          ]);
        }
      });
    } else {
      this.dialogRef.close(null);
    }
  }

  clear() {
    clearPad(this.signaturePad);
  }

  scrollTop(up: boolean) {
    var elId = up ? 'receipt_top' : 'sign_area';
    var el = document.getElementById(elId);
    var contentEl = document.getElementById('receipt_content');
    if (el && contentEl) {
      //const elRect = getClientRect(el);
      //console.log('RECT:', elRect, isFunction(contentEl.scrollTo));
      el.scrollIntoView({
        behavior:'smooth'
      });
      //tryToScrollY(contentEl, 200);
    }
  }
}
